module.exports = __webpack_public_path__ + "img/banner.3f22f2b.png";